import React from "react";
import { IoIosSearch } from "react-icons/io";
import { TbColumns3 } from "react-icons/tb";
import { CiTextAlignJustify } from "react-icons/ci";
import { GoColumns } from "react-icons/go";
import { strings } from "../../../strings/strings";

const CompanyFilters = ({ 
  searchQuery, 
  setSearchQuery, 
  selectedStatus, 
  setSelectedStatus, 
  sortBy, 
  setSortBy,
  gridView,
  setGridView,
  totalCompanies
}) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-3 sm:p-4 mb-6">
      {/* Mobile Layout */}
      <div className="flex flex-col gap-3 lg:hidden">
        <div className="relative w-full">
          <IoIosSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder={strings.SEARCH_PLACEHOLDER}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            id="company-search-input"
            className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>

        {/* Filters Row */}
        <div className="flex gap-2">
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            className="flex-1 px-2 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="all">{strings.ALL_STATUS}</option>
            <option value="active">{strings.ACTIVE}</option>
            <option value="suspended">{strings.SUSPENDED}</option>
          </select>

          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="flex-1 px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary"
          >
        <option value="desc">{strings.NEWEST_FIRST}</option>
            <option value="asc">{strings.OLDEST_FIRST}</option>
          </select>
        </div>

        {/* Grid View Controls & Count */}
        <div className="flex items-center justify-between">
          {/* Grid options - Hidden on mobile, shown on desktop */}
          <div className="hidden sm:flex items-center gap-2">
            <button
              onClick={() => setGridView("three")}
              className={`p-2 rounded-lg border transition-all ${
                gridView === "three"
                  ? "bg-primary/10 dark:bg-primary/30 border-primary text-primary-dark dark:text-primary"
                  : "bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700"
              }`}
              title={strings.THREE_COLUMNS}
            >
              <TbColumns3 className="w-4 h-4" />
            </button>
            <button
              onClick={() => setGridView("two")}
              className={`p-2 rounded-lg border transition-all ${
                gridView === "two"
                  ? "bg-primary/10 dark:bg-primary/30 border-primary text-primary-dark dark:text-primary"
                  : "bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700"
              }`}
              title={strings.TWO_COLUMNS}
            >
              <GoColumns className="w-4 h-4" />
            </button>
            <button
              onClick={() => setGridView("one")}
              className={`p-2 rounded-lg border transition-all ${
                gridView === "one"
                  ? "bg-primary/10 dark:bg-primary/30 border-primary text-primary-dark dark:text-primary"
                  : "bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700"
              }`}
              title={strings.ONE_COLUMN}
            >
              <CiTextAlignJustify className="w-4 h-4" />
            </button>
          </div>
          <span className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
            {strings.THEREARE} {totalCompanies} {strings.COMPANIES}
          </span>
        </div>
      </div>

           <div className="hidden lg:grid grid-cols-3 gap-4">
        <div className="col-span-2 flex gap-3 items-start">
          <div className="relative w-[400px]">
            <IoIosSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              placeholder={strings.SEARCH_PLACEHOLDER}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              id="company-search-input-desktop"
              className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="all">{strings.ALL_STATUS}</option>
            <option value="active">{strings.ACTIVE}</option>
            <option value="suspended">{strings.SUSPENDED}</option>
          </select>

          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="desc">{strings.NEWEST_FIRST}</option>
            <option value="asc">{strings.OLDEST_FIRST}</option>
          </select>
        </div>
        <div className="col-span-1 flex items-start justify-end gap-4">
          <div className="flex flex-row lg:flex-row  xl:flex-row items-center gap-2">
           
            <div className=" flex items-center gap-2">
            <button
              onClick={() => setGridView("three")}
              className={`p-2 rounded-lg border transition-all ${gridView === "three"
                ? "bg-primary/10 dark:bg-primary/30 border-primary text-primary-dark dark:text-primary"
                : "bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700"
                }`}
              title={strings.THREE_COLUMNS}
            >
              <TbColumns3 className="w-4 h-4" />
            </button>
            <button
              onClick={() => setGridView("two")}
              className={`p-2 rounded-lg border transition-all ${gridView === "two"
                ? "bg-primary/10 dark:bg-primary/30 border-primary text-primary-dark dark:text-primary"
                : "bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700"
                }`}
              title={strings.TWO_COLUMNS}
            >
              <GoColumns className="w-4 h-4" />
            </button>
            <button
              onClick={() => setGridView("one")}
              className={`p-2 rounded-lg border transition-all ${gridView === "one"
                ? "bg-primary/10 dark:bg-primary/30 border-primary text-primary-dark dark:text-primary"
                : "bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700"
                }`}
              title={strings.ONE_COLUMN}
            >
              <CiTextAlignJustify className="w-4 h-4" />
            </button>
            </div>
            <div className="flex items-center">
            <span className="ml-2 text-xs text-gray-600 dark:text-gray-400">{strings.THEREARE} {totalCompanies} {strings.COMPANIES}.</span>
            </div>
             
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyFilters;
